export const CREATE_STATEMENT_TEMPLATE_REQUEST = 'CREATE_STATEMENT_TEMPLATE_REQUEST';

export const createStatementTemplateRequest = ( statementTemplate ) => ({
    type: CREATE_STATEMENT_TEMPLATE_REQUEST,
    payload: { ...statementTemplate },
});
